import React, { useState } from "react";
import client from "../../../shared/api/client";
import { toastSuccess, toastError } from "../../../shared/toastHelper";

const MetaAdAccountSelector = ({
  csrfToken,
  metaAdsAccessId,
  availableAccounts,
  selectedAccountIds,
  integrationDetailsPath,
}) => {
  const [selected, setSelected] = useState(new Set(selectedAccountIds || []));
  const [submitting, setSubmitting] = useState(false);

  const toggleAccount = (accountId) => {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(accountId)) {
        next.delete(accountId);
      } else {
        next.add(accountId);
      }
      return next;
    });
  };

  const canSubmit = selected.size > 0;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmit || submitting) return;

    setSubmitting(true);
    try {
      const selectedAccounts = availableAccounts.filter((a) =>
        selected.has(a.external_account_id)
      );

      await client.patch(`/meta_ads_accesses/${metaAdsAccessId}`, {
        authenticity_token: csrfToken,
        accounts: selectedAccounts,
      });

      toastSuccess("Ad accounts saved successfully.");
      window.location.href = integrationDetailsPath;
    } catch {
      toastError("Failed to save ad accounts. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="col-12 col-md-8 offset-md-2">
      <div className="card mt-5 shadow-3">
        <div className="card-body text-center">
          <br />
          <h2>
            <strong>Select your ad accounts</strong>
          </h2>
          <br />
          <div className="col-12 col-lg-8 offset-lg-2">
            <p>
              Your Meta account is associated with the following ad accounts.
              Choose the accounts you'd like to track in Opendate.
            </p>
            <br />
            {availableAccounts.length === 0 ? (
              <p className="text-muted">
                No ad accounts found for this Meta account.
              </p>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="text-left">
                  {availableAccounts.map((account) => (
                    <div
                      className="custom-control custom-checkbox mb-2"
                      key={account.external_account_id}
                    >
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id={`account-${account.external_account_id}`}
                        checked={selected.has(account.external_account_id)}
                        onChange={() =>
                          toggleAccount(account.external_account_id)
                        }
                      />
                      <label
                        className="custom-control-label setlist-text-md"
                        htmlFor={`account-${account.external_account_id}`}
                      >
                        {account.name}{" "}
                        <span className="text-muted">
                          ({account.currency}, {account.timezone_name})
                        </span>
                      </label>
                    </div>
                  ))}
                </div>
                <br />
                <div className="text-center">
                  <button
                    type="submit"
                    className="btn btn-setlist-primary"
                    disabled={!canSubmit || submitting}
                  >
                    {submitting ? "Saving..." : "Save and Continue"}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetaAdAccountSelector;
